import React from "react";

/**
 * Status chip. Same status name renders the same hue in every theme.
 * @param {Object} props
 * @param {"live"|"demo"|"notcfg"|"deferred"|"superseded"|"approved"|"rejected"|"pending"|"expired"} props.status
 * @param {React.ReactNode} [props.children]
 */
export function Chip({ status, children }) {
  return (
    <span className={`ds-chip ds-chip-${status}`}>
      <span className="ds-chip-dot" />
      {children ?? DEFAULT_LABELS[status] ?? status}
    </span>
  );
}

const DEFAULT_LABELS = {
  live: "Live",
  demo: "Demonstration",
  notcfg: "Not configured",
  deferred: "Deferred",
  superseded: "Superseded",
  approved: "Approved",
  rejected: "Rejected",
  pending: "Pending",
  expired: "Expired",
};
